export default __webpack_public_path__ + "static/giant-5-d3c19945f3635377bde9382b5eb1613c.jpg";